import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { WaterFallContainerComponent } from '../../../common/components/water.fall.container/water.fall.container.component';
import { HubEvent } from '../../../models/hub/hub.event';
import { HubApiService } from '../../../services/hub.api.service';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ButtonTriggerEvent } from '../../../common/components';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { ModalService } from '../../../common/services/modal.service';
import { EditEventModalActions } from '../edit.event.modal/edit.event.modal.provider';
import { EditEventModalComponent } from '../edit.event.modal/edit.event.modal.component';
import { ImageService } from '../../../services/image.service';
import { HubCustomBtn } from '../../../models/hub/hub.custom.btn';
import { CustomBtnStore } from '../../../stores/hub.calendar.store';
import { CustomEventCommand } from '../../../commands/hub/custom.event.command';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { ShowPromptModalComponent } from '../show.prompt.modal/show.prompt.modal.component';
import { PromptModalData, ShowPromptModalActions } from '../show.prompt.modal/show.prompt.modal.provider';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { HubPlace } from '../../../models/hub/hub.place';
import { EditPlaceModalComponent } from '../edit.place.modal/edit.place.modal.component';
import { EditPlaceModalActions } from '../edit.place.modal/edit.place.modal.provider';

@Component({
  selector: 'ig-hub-similar-place-calendar',
  templateUrl: './hub.similar.place.calendar.component.html',
  styleUrls: ['./hub.similar.place.calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HubSimilarPlaceCalendarComponent extends BaseComponent implements OnInit, AfterContentChecked {
  public hubName: string;
  public isAllDataLoaded: boolean;
  public isLoading: boolean;
  public isNoContent = false;
  public isNoContentFor2ParamSimilarity = false;
  public isNoContentForMultiDatesEvents = false;
  public isOperating = false;
  public group = -1;
  public hasMoreGroups = true;
  public groupSize = 500;
  public allPlaceCount = 0;

  public similarPlaces: {
    group: HubPlace[];
    condition: SimilarPlaceCondition[];
  }[];

  public customBtns = new HubCustomBtn();

  @ViewChild('spinner') private spinner: PageSpinnerComponent;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private hubApiService: HubApiService,
    private modalService: ModalService,
    public imageService: ImageService,
    public changeDetector: ChangeDetectorRef,
    private customBtnStore: CustomBtnStore
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;

    this.customBtnStore.customBtnCommand.takeUntil(this.isDestroyed).subscribe((btns: HubCustomBtn) => {
      this.customBtns = btns || new HubCustomBtn();
    });

    // this.getSimilarPlaces();
  }

  public getSimilarPlaces(event?: ButtonTriggerEvent) {
    this.group += 1;
    this.group === 0 && this.showSpinner();
    this.hubApiService
      .getSimilarPlaces(this.hubName, this.group)
      .finally(event && event.complete)
      .subscribe((data) => {
        console.log(data);
        this.hasMoreGroups = data.hasMoreGroups;
        this.groupSize = data.groupSize;
        this.allPlaceCount = data.allPlaceCount;
        if (this.group === 0) {
          this.similarPlaces = data.similarPlaces;
        } else {
          this.similarPlaces = this.similarPlaces.concat(data.similarPlaces);
        }
        // this.isNoContent = !this.similarPlaces || !this.similarEventsByExactSame.length;
        // this.isNoContentForMultiDatesEvents = !this.similarMultiDatesEvents || !this.similarMultiDatesEvents.length;
        this.hideSpinner();
      });
  }

  ngAfterContentChecked() {
    this.changeDetector.detectChanges();
  }

  public getCount(type) {
    if (!type || !type.length) return 0;

    let count = 0;
    type.forEach((x) => {
      count += x.group.length;
    });
    return count;
  }

  public isSimilarField(field: string, placeId: string, conditions: SimilarPlaceCondition[]) {
    const condition = conditions.find((x) => x.field === field);
    if (!condition) return false;

    return condition.places.indexOf(placeId) >= 0;
  }

  public approve(place: HubPlace) {
    this.isOperating = true;
    this.hubApiService
      .approvePlace(this.hubName, place._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        place.isApproved = true;
      });
  }

  public unApprove(place: HubPlace) {
    this.isOperating = true;
    this.hubApiService
      .unApprovePlace(this.hubName, place._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        place.isApproved = false;
      });
  }

  public showEditModal(place: HubPlace) {
    let actions = <EditEventModalActions>{
      confirm: ($event: ButtonTriggerEvent, e: HubEvent, image: string) => {
        this.getSimilarPlaces();
      },
    };

    this.hubApiService.getPlacesByPlaceIds(this.hubName, [place._id]).subscribe((data) => {
      console.log(data);
      let p = data[0];
      // reorganize address object for backend
      p.address = {
        address: p.address.toString(),
        lat: p.lat,
        lng: p.lng,
        address_components: p.address_components,
      };
      this.modalService.show({
        component: EditPlaceModalComponent,
        providers: [
          { provide: EditPlaceModalActions, useValue: actions },
          { provide: HubPlace, useValue: p },
        ],
        panelClass: 'width-modal-2',
      });
    });
  }

  public block(place: HubEvent) {
    let actions = <ConfirmModalActions>{
      confirm: ($event: ButtonTriggerEvent) => {
        this.hubApiService
          .blockPlace(this.hubName, place._id)
          .finally($event.complete)
          .subscribe(() => {
            this.getSimilarPlaces();
            const doNotShowModal = localStorage.getItem(localStorageKeys.doNotShowRemoveSuccessfullyModal);
            if (!doNotShowModal) {
              this.showRmoveSuccessModal();
            }
          });
      },
      cancel: () => {
        this.isOperating = false;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this place?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  /**
   * remove the delete event button for pulled events, as some clients are confused that if they delete an event, it will be added in the next pull
   * */
  public deletePermanently(event: HubEvent) {
    let actions = <ConfirmModalActions>{
      confirm: ($event: ButtonTriggerEvent) => {
        this.hubApiService
          .deleteEvent(this.hubName, event._id)
          .finally($event.complete)
          .subscribe(() => {
            this.getSimilarPlaces();
          });
      },
      cancel: () => {
        this.isOperating = false;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription:
        'Are you sure you want to delete this event permanently, this operation cannot be reverted?',
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public isInCustomBtn(event: HubEvent, btn?: CustomEventCommand) {
    if (btn) {
      return btn.events.any((x) => x === event._id);
    } else {
      let isIn = false;
      if (this.customBtns.events) {
        for (let x of this.customBtns.events) {
          if (x.events.any((x) => x === event._id)) {
            isIn = true;
            break;
          }
        }
      }
      return isIn;
    }
  }

  public addOrRemoveToCustomBtn(event: HubEvent, btn: CustomEventCommand, index: number) {
    if (!this.isInCustomBtn(event, btn)) {
      this.hubApiService.addEventToCustomBtn(this.hubName, event._id, index).subscribe((customEvents) => {
        this.customBtns.events = customEvents;
      });
    } else {
      this.hubApiService.removeEventFromCustomBtn(this.hubName, event._id, index).subscribe((customEvents) => {
        this.customBtns.events = customEvents;
      });
    }
  }

  public async gotoTours() {
    await this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.tours, {
        hubName: this.hubName,
      })
    );
  }

  private showSpinner() {
    this.isLoading = true;
    this.spinner.show();
  }

  private hideSpinner() {
    setTimeout(() => {
      this.isLoading = false;
      this.spinner.hide();
    });
  }

  private showRmoveSuccessModal() {
    this.modalService.show({
      component: ShowPromptModalComponent,
      providers: [
        { provide: ShowPromptModalActions, useValue: null },
        {
          provide: PromptModalData,
          useValue: new PromptModalData('Remove successfully', null, [
            'The selected item has been successfully removed from the dashboard.',
            'You can restore this item from the Removed List at any time.',
            'While in the Removed List, this item cannot be pulled again.',
          ]),
        },
      ],
      panelClass: 'width-modal-2',
    });
  }
}

export class SimilarPlaceCondition {
  field: string;
  places: string[];
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/similar.place.calendar/hub.similar.place.calendar.component.ts